<template>
  <div id="app">
    <div id="nav">
      <div v-if="!isAuth()">
        <router-link to="/">Home</router-link> |
        <!-- <router-link to="/demo">Demo</router-link> | -->
        <!-- <router-link to="/main/dashboard">Main</router-link> | -->
        <router-link to="/login">Login</router-link> |
        <router-link to="/register">Register</router-link> |
        <router-link to="/about">About</router-link> 

      </div>
        
      <div v-if="isAuth()">
        <router-link to="/main/dashboard">Main</router-link> |
        <a v-if="isAuth()"  @click="logout">Logout</a> |
        <router-link to="/about">About</router-link> 
      </div>
      
      

      

      
      
    </div>
    <router-view/>

    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.2.0/css/all.css">
  </div>


</template>

<script>
    import { AUTH_REQUEST, AUTH_LOGOUT} from '@/store/actions/auth'
    import { mapState } from 'vuex'
    // import store from './store'

    export default {
      name: 'App',
      methods: {
        // login: function () {
        //   const { username, password } = this;
        //   this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
        //     this.$router.push('/user/xxx/dashboard')
        //   })
        // },
        logout: function () {
          this.$store.dispatch(AUTH_LOGOUT).then(() => {
            this.$router.push('/login')
          })
        },
        isAuth: function () {
          return this.$store.getters.isAuthenticated
        }
      },
      // computed: mapState(['getProfile']),
      // watch: {
      //   getProfile(newValue, oldValue) {
      //     console.log(`Updating from ${oldValue} to ${newValue}`);
      //   }
      // }
    }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
